module.exports = __webpack_public_path__ + "static/06-d22ea95c2d4a1925266b1ee450dfe8c4.jpg";